import { extractWorkflowFromInstanceName } from '@spotify/confidence-core-react';
import {
  CollectionEntryWorkflowInstanceFieldsFragmentDoc,
  isType,
} from '@spotify/confidence-graphql';
import {
  type CollectionEntryOptions,
  createCollectionEntryExtension,
} from '@spotify/plugin-confidence-collections-react';
import {
  useWorkflowExtension,
  workflowInstanceRouteRef,
} from '@spotify/plugin-confidence-workflows-react';

import { workflowsPlugin } from '../plugin';

const WorkflowInstanceResourceType = ({
  resource,
}: {
  resource: CollectionEntryOptions['resource'];
}) => {
  const resourceName = 'name' in resource ? String(resource.name) : undefined;
  const workflowId = extractWorkflowFromInstanceName(resourceName ?? '') ?? '';
  const extension = useWorkflowExtension({ workflowId });
  return <>{extension?.title ?? 'Experiment'}</>;
};

export const WorkflowInstanceCollectionEntryExtension = workflowsPlugin.provide(
  createCollectionEntryExtension({
    id: 'workflow-instance',
    resourceType: 'WorkflowInstance',
    routeRef: workflowInstanceRouteRef,
    getRouteParams: name => ({
      workflow: extractWorkflowFromInstanceName(name) || '',
    }),
    fragment: CollectionEntryWorkflowInstanceFieldsFragmentDoc,
    predicate: ({ resource }) => isType(resource, 'WorkflowV1WorkflowInstance'),
    ResourceTypeLabel: WorkflowInstanceResourceType,
    render: () => null,
  }),
);
